module.exports = __webpack_public_path__ + "assets/img/2_816.19a641ff.jpg";